export default class GlobalCssStrings {
    static readonly KBD = "bg-black dark:bg-white text-white dark:text-black py-1 px-2 rounded-md";
    static readonly InputCSS = "rounded-md border border-gray-300 shadow-sm px-4 py-2";
}